import { useEffect } from 'react';
import scopeTab from 'react-modal/lib/helpers/scopeTab';
import { EVENT_KEY_TAB } from '../utils/event-key-names';

/**
 * Custom hook that traps focus within a container using the scopeTab function from react-modal.
 *
 * @param {React.RefObject} ref - The ref to the container element.
 * @param {Object} options - Configuration options for the hook.
 * @param {boolean} options.shouldTrapFocus - Determines whether focus should be trapped or not.
 * @returns {React.RefObject} - The same ref object passed as argument.
 */
const useFocusTrap = (ref, options = {}) => {
  const {
    shouldTrapFocus = true
  } = options;
  useEffect(() => {
    if (!shouldTrapFocus || ref?.current == null) return undefined;
    const element = ref.current;
    const handleKeyDown = event => {
      if (event.key === EVENT_KEY_TAB) {
        scopeTab(element, event);
      }
    };
    element.addEventListener('keydown', handleKeyDown);
    return () => {
      element.removeEventListener('keydown', handleKeyDown);
    };
  }, [ref, shouldTrapFocus]);
  return ref;
};
export default useFocusTrap;
//# sourceMappingURL=useFocusTrap.js.map